<template>
  <conditional-section :active="active">
    <list2
      :active="active"
      :filter="filter"
      :file-type="this.dataType"
      :fetch="fetch"
      :table_data="this.table_data"
      :table_columns="this.table_columns"
      :database="this.database"
      :already_loaded="this.already_loaded"
      :enable-filter="this.enableFilter"
      enable-action
      @act="goTo360View"
      :enable-sort="!disableSort"
      :enable-download="!disableDownload"
      :report_title="this.report_title"
      @download="downloadCSV"
      @actAll="sendDataAsMail"
      action-text="view"/>
  </conditional-section>
</template>

<script>
import ConditionalSection from './ConditionalSection';
import {E_DOWNLOAD, eventHub, fullURL} from '../../utils';
import List2 from '../List/List2';
import axios from "axios";
import {fetchAllTargetReports, fetchListReports, fetchTargetReports} from "@/components/Insights/utils";

export default {
  name: 'CustomerListSection',

  components: {
    ConditionalSection,
    List2
  },

  props: {
    dataType: String,
    database: String,
    filter: Object | String,
    active: Boolean,
    disableDownload: Boolean,
    disableSort: Boolean,
    enableFilter: Boolean,
    already_loaded: Boolean,
    table_data: Array,
    table_columns: Array,
    selected_report_id: String,
    selected_dashboard_id: String,
    report_title: String,
    target_year: Number,
    start_date: String,
    end_date: String
  },

  methods: {
    fetch(params) {
      // return fetchInsight('CustomerList', {...this.filter, database: this.database, collection: this.dataType}, params);
      console.log(params)
      console.log("selected report in list section", this.selected_report_id)
      console.log("selected dashboard in list section", this.selected_dashboard_id)
      params["report_id"] = this.selected_report_id
      params["dashboard_id"] = this.selected_dashboard_id
      if (this.selected_dashboard_id === "TARGETS") {
        if (this.selected_report_id === "all_targets") {
          return fetchAllTargetReports()
        } else {
          return fetchTargetReports(this.selected_report_id, this.target_year)
        }
      } else {
        return fetchListReports(params, this.start_date, this.end_date);
      }

    },

    downloadCSV(params) {
      eventHub.$emit(E_DOWNLOAD, {
        filter: {...this.filter, database: this.database, collection: this.dataType},
        params
      });
    },

    goTo360View(record) {
      const userFile = this.$store.getters.getActiveFile(this.dataType);
      console.log("datatype", this.dataType);
      console.log("database", this.database);
      console.log("userfile", userFile);
      console.log("record", record);
      const record_id = record["_id"];
      // this.$emit('360_collection', this.dataType);
      // const idField = userFile.entityMap['customer_no'];
      // const customerID = record[idField];
      this.$router.push(`/360/${this.database}/${this.dataType}/${record_id}`);
      // this.$router.push(`/customer360/${6}`);
    },

    sendDataAsMail(record) {
      const confirmed_email = record["confirmed_email"]
      // console.log("selected report to send", this.selected_report)
      console.log("sending email", this.selected_dashboard_id)
      let target_id = this.selected_report_id

      axios({
          method: 'post',
          url: this.selected_dashboard_id === "TARGETS" ? fullURL(`/dashboards/target/email/${target_id}`) :
            fullURL(`/dashboards/report/email/${this.selected_report_id}`),
          data: {
            "email": confirmed_email,
            "target_year": this.target_year,
            "start_date": this.start_date,
            "end_date": this.end_date
          }

        }
      ).then(
        ({data}) => {
          console.log("Email Sent")

        }
      );
    },
  }
};
</script>
